// Google Ads conversion tracking (client-side, gtag.js).
// gtag.js se učitava u public/index.html — samo ako je REACT_APP_GADS_CONVERSION_ID postavljen.
// Ovde je jedini poziv koji frontend treba: trackPurchase(...) na stranici uspeha porudžbine.

const CONVERSION_ID = (process.env.REACT_APP_GADS_CONVERSION_ID || '').trim();
const CONVERSION_LABEL = (process.env.REACT_APP_GADS_CONVERSION_LABEL || '').trim();

function gtagReady() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/** True kada su ID i label podešeni i gtag učitan (inače su pozivi no-op). */
export function analyticsEnabled() {
  return gtagReady() && Boolean(CONVERSION_ID) && Boolean(CONVERSION_LABEL);
}

/**
 * Okida Google Ads „purchase" konverziju. Pozvati JEDNOM na stranici uspeha porudžbine.
 *
 * @param {object} order
 * @param {string} order.transactionId  orderNumber iz POST /orders (sprečava duple konverzije)
 * @param {number} order.value          ukupan iznos (total)
 * @param {string} [order.currency]     podrazumevano RSD
 */
export function trackPurchase({ transactionId, value, currency = 'RSD' }) {
  if (!analyticsEnabled()) return;
  window.gtag('event', 'conversion', {
    send_to: `${CONVERSION_ID}/${CONVERSION_LABEL}`,
    value: typeof value === 'number' ? value : Number(value) || 0,
    currency,
    transaction_id: transactionId ? String(transactionId) : '',
  });
}
